<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card" *ngIf="moduleAccess=='Full'">
	<h2 class="card-title mb-0 pb-0">
		Profile
		<a class="btn btn-sm btn-outline-success float-end" [routerLink]="['/app/create-profile']">
			<fa-icon [icon]="['fas', 'plus']"></fa-icon>
			Create Profile
		</a>
	</h2>
	<div class="card-body pt-1">
		<div class="row">
			<div class="col-md-12">
				<div class="table-responsive">
					<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover"
						style="width: 100%;">
						<thead>
							<tr class="table_head">
								<th style="width: 20% !important;">Profile</th>
								<th style="width: 70% !important;">Description</th>
								<th style="width: 10% !important;">Action</th>
							</tr>
						</thead>
						<tbody *ngIf="dataList?.length != 0">
							<tr *ngFor="let v of dataList;let i = index;">
								<td>{{ v.name }}</td>
								<td>{{ v.description }}</td>
								<td>
									<a class="btn btn-xs btn-outline-primary" matTooltip="Edit" id="btnEdit{{v.id}}"
										[routerLink]="['/app/edit-profile',v.apptid1]">
										<fa-icon [icon]="['fas', 'edit']"></fa-icon>
									</a>
									<button type="button" class="btn btn-xs btn-outline-danger ms-1" matTooltip="Delete"
										id="btnDelete{{v.id}}" (click)="deleteConfirm(v.apptid1,i)">
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
									</button>
								</td>
							</tr>
						</tbody>
						<tbody *ngIf="dataList?.length == 0">
							<tr>
								<td colspan="3" class="text-center">No data found!</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="moduleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>